import React from "react";
import { STRINGS } from "constants/strings.constant";
import { PriceQuoteSummaryProps } from "interfaces/payment_modal.interface";
import "./price_quote_summary.component.scss";

// The cream box under the targets: what the price is before tax, the tax in it, and what the customer pays.
const PriceQuoteSummary = (props: PriceQuoteSummaryProps): React.ReactElement => (
    <div className="price_quote_summary">
        <div className="price_quote_summary_line">
            <span>{STRINGS.priceQuote.subtotal}</span>
            <span>{props.subtotal}</span>
        </div>
        <div className="price_quote_summary_line">
            <span>{STRINGS.priceQuote.gst}</span>
            <span>{props.gst}</span>
        </div>
        <div className="price_quote_summary_total">
            <span className="price_quote_summary_total_label">{STRINGS.priceQuote.total}</span>
            <span className="price_quote_summary_total_amount">{props.total}</span>
        </div>
    </div>
);

export default PriceQuoteSummary;
